import React from 'react';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import ItemList from '../../../shared/ItemList';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import InterlibraryLoanItem from '../InterlibraryLoanItem';
import CompactList from '../../../shared/CompactList';

import './InterlibraryLoansList.scss';

function renderListItem(item) {
  return (
    <InterlibraryLoanItem item={item} key={item.get('id')} />
  );
}

class InterlibraryLoansList extends BcReactComponent {

  render() {
    const { items } = this.props;
    return (
      <div className="cp-interlibraryloans-list">
        <ItemList>
          <FormattedMessage id="ill_active_requests_message">
            {
              (message) => (
                message !== 'ill_active_requests_message'
                  ? <p className="interlibrary-loans-help">{message}</p>
                  : null
              )
            }
          </FormattedMessage>
          <CompactList>
            {items.map(item => renderListItem(item))}
          </CompactList>
        </ItemList>
      </div>
    );
  }
}

InterlibraryLoansList.propTypes = {
  items: ImmutablePropTypes.map
};


export default InterlibraryLoansList;



// WEBPACK FOOTER //
// ./app/components/borrowing/interlibraryLoans/InterlibraryLoansList/InterlibraryLoansList.jsx